import React from 'react';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;

const MetadataSection = ({ 
  sectionKey, 
  sectionData, 
  currentLanguage 
}) => {
  const { t } = useTranslation();

  const langKey = currentLanguage.toLowerCase();
  const getFieldName = (field) => ['content', langKey, 'meta', field];

  return (
    <>
      <Form.Item
        name={getFieldName('title')}
        label={t('Meta Title')}
      >
        <Input 
          placeholder={t('Inserisci il meta title')} 

        />
      </Form.Item>

      <Form.Item
        name={getFieldName('description')}
        label={t('Meta Description')}
      >
        <TextArea 
          placeholder={t('Inserisci la meta description')} 
          rows={3}


        />
      </Form.Item>

      <Form.Item
        name={getFieldName('url')}
        label={t('Canonical URL')}
      >
        <Input 
          placeholder={t('Inserisci il canonical URL (es: /vip-club o https://example.com)')} 
        />
      </Form.Item>
    </>
  );
};

export default MetadataSection; 